import Vue from 'vue'
import newGift from './newGift'
import addrCom from './addressCom'
import footerCom from './footerCom'
import originality from './originality'
import caseItemCom from './caseItemCom'

import rightKefuBtn from './rightKefuBtn'

import caseSearchCom from './caseSearchCom'
import downTime from './downTime'
import field from './field'
import headerCom from './headerCom'
import homeNotice from './homeNotice'

import homeSwiper from './homeSwiper'
import hotService from './hotService'
import listItemNew from './listItemNew'
import mySwitch from './my-switch'
import numCount from './numCount'
import paygoodsItem from './paygoodsItem'
import previewer from './previewer'
import question from './question'
import radio from './radio'
import radio1 from './radio1'
import radioB from './radioB'
import rolling from './rolling'
import selectAddress from './selectAddress'
import selectAdress1 from './selectAdress1'
import selectAddress2 from './selectAddress2'
import tiwoSelectAddress from './tiwoSelectAddress'
import serviceEntry from './serviceEntry'
import serviceListItem from './serviceListItem'
import tabCom from './tabCom'
import teamInfo from './teamInfo'
import uploadCom from './uploadCom'

Vue.component(rightKefuBtn.name, rightKefuBtn);
Vue.component(newGift.name, newGift);
Vue.component(addrCom.name, addrCom);
Vue.component(footerCom.name, footerCom);
Vue.component(originality.name, originality);
Vue.component(caseItemCom.name, caseItemCom);
Vue.component(caseSearchCom.name, caseSearchCom);
Vue.component(downTime.name, downTime);
Vue.component(field.name, field);
Vue.component(headerCom.name, headerCom);
Vue.component(homeNotice.name, homeNotice);
Vue.component(homeSwiper.name, homeSwiper);
Vue.component(hotService.name, hotService);
Vue.component(listItemNew.name, listItemNew);
Vue.component(mySwitch.name, mySwitch);
Vue.component(numCount.name, numCount);
Vue.component(paygoodsItem.name, paygoodsItem);
Vue.component(previewer.name, previewer);
Vue.component(question.name, question);
Vue.component(radio.name, radio);
Vue.component(radio1.name, radio1);
Vue.component(radioB.name, radioB);
Vue.component(rolling.name, rolling);
Vue.component(selectAddress.name, selectAddress);
Vue.component(selectAdress1.name, selectAdress1);
Vue.component(selectAddress2.name, selectAddress2);
Vue.component(serviceEntry.name, serviceEntry);
Vue.component(serviceListItem.name, serviceListItem);
Vue.component(tabCom.name, tabCom);
Vue.component(teamInfo.name, teamInfo);
Vue.component(uploadCom.name, uploadCom);
Vue.component(tiwoSelectAddress.name, tiwoSelectAddress);

// const componentsContext = require.context('./', true, /\.vue$/)
// console.log(componentsContext.keys())
// componentsContext.keys().forEach(component => {
//   console.log(component)
//   const componentConfig = componentsContext(component)
//   /**
//    * 兼容 import export 和 require module.export 两种规范
//    */
//   const ctrl = componentConfig.default
//   Vue.component(ctrl.name, ctrl)
// })


/**
 * 通用业务组件
 */
// exports.install = (Vue, options) => {
//   // 获取所有扫描到的组件
//   // const requireComponent = require.context('./', true, /\.vue$/);
//   // console.log(requireComponent);
 
//   // (component => {
//   //     // 遍历获取组件对象，注册组件
//   //     component.keys().map(fileName => {
//   //         const com = requireComponent(fileName);
//   //         // if(com.hasOwnProperty("name")) {
//   //         //     const componentname = com.name;
//   //         //     Vue.component(componentname, com);
//   //         // }
//   //     });
//   // })(requireComponent);
 
//  }